import { getActions, getReducers, getTypes } from '../initializers';

/**
 * Signed-in viewer's CURRENT loyalty balance on each channel they have earned
 * on. Balances live per-streamer on the Bets table, so there is no single
 * global number to read off the user record — the wallet headline is the sum
 * of these rows, and each row is what that channel will actually let you spend.
 */
const identifier = 'POINTS_BALANCES';

export const getBalancesState = (state) => state.points?.balances;

export const types = getTypes(identifier);
export const actions = getActions(identifier, () => 'rngroyale/balances/me');
const reducer = getReducers(identifier);

export default reducer;
